export function createMusicOrchestrator(context = {}) {
  const {
    state,
    ensureMusicPlayerReady,
    showToast
  } = context;

  let warmupScheduled = false;

  function renderMusic() {
    if (state?.music?.initialized) return;
    ensureMusicPlayerReady()
      .catch(() => {
        showToast?.('音乐模块加载失败');
      });
  }

  function scheduleWarmup() {
    if (warmupScheduled || state?.music?.initialized) return;
    warmupScheduled = true;

    const warm = () => {
      ensureMusicPlayerReady().catch(() => {});
    };

    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => warm(), { timeout: 3500 });
      return;
    }
    setTimeout(warm, 900);
  }

  return {
    renderMusic,
    scheduleWarmup
  };
}
